import React from 'react'

export default function TimetableTipsCard() {
  const tips = [
    {
      title: 'Targeted Weekly Day',
      description: 'Time Table has to be targeted for a specific recurring day of the week (e.g. Monday, Wednesday).',
    },
    {
      title: 'Single vs All Scope',
      description: 'Time-Table entries can be created for Single or Multiple Branches / Batches / Schools by choosing the "All" option.',
    },
    {
      title: 'School / College Selection',
      description: 'Choose School/College name for lectures targeted for students of a particular institution based on curriculum.',
    },
    {
      title: 'Conflict Prevention',
      description: 'Time-Table entries are validated to avoid overlapping schedules for Faculty, Student Batches, and Classrooms.',
    },
    {
      title: 'Time Formats',
      description: 'Ensure accurate From and Till times in standard 12-hour AM/PM format for precise recurring schedules.',
    },
  ]

  return (
    <div className="rounded-3xl border border-outline-variant/30 bg-surface-container-lowest p-6 shadow-xs">
      <div className="flex items-center gap-2.5">
        <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <span className="material-symbols-outlined text-lg">lightbulb</span>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold text-on-surface">Scheduling Tips</h3>
          <p className="text-[11px] text-on-surface-variant">Best practices for timetable configuration</p>
        </div>
      </div>

      <div className="mt-5 flex flex-col gap-4">
        {tips.map((tip, idx) => (
          <div key={idx} className="flex items-start gap-3 text-xs">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-[10px] font-black text-primary">
              {idx + 1}
            </span>
            <div className="flex-1">
              <p className="font-bold text-on-surface">{tip.title}</p>
              <p className="mt-0.5 text-[11px] leading-relaxed text-on-surface-variant">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
